import React, { Component } from 'react';
import Notifications from './Notifications.js';
import axios from 'axios';
import { MENU } from '../Sidebar.js';
import { translate } from 'react-i18next';

export const MEDIUM = {
  CALL: "Llamo",
  VISIT: "Vino"
};

let cancelToken;
let state;
let tokenSession;

class AssistantContainer extends Component {

  constructor(props) {
    super(props);
    if (tokenSession !== props.getTokenSession()) {
      state = this.getInitState();
    }
    this.state = state;
  }

  componentWillMount() {
    cancelToken = axios.CancelToken.source();
  }

  componentDidMount() {
    this.reload();
  }

  componentWillUnmount() {
    cancelToken.cancel('Component will unmount.');
    state = this.state;
    tokenSession = this.props.getTokenSession();
  }

  didGetNotifications = (response) => {
    this.setState({ notifications: response });
  }

  getAssistantNotifications = (params) => {
    this.props.post(
      "/getAssistantNotifications",
      params,
      (response) => this.didGetNotifications(response),
      (error) => this.props.handleErrorResponse(error),
      cancelToken
    );
  }

  getInitState = () => {
    return { notifications: null };
  }

  hasNotifications = () => {
    return this.state.notifications
      && (this.state.notifications.deliveries.length > 0
        || this.state.notifications.messages.length > 0);
  }

  joinNotifications = () => {
    let notifications = this.state.notifications.deliveries.slice();
    notifications = notifications.concat(this.state.notifications.messages);

    return notifications.sort((a, b) => {
      if (a.date > b.date)
        return -1;
      if (a.date < b.date)
        return 1;
      return 0;
    });
  }

  reload = () => {
    this.getAssistantNotifications({
      token_id: this.props.getTokenId(),
      token_session: this.props.getTokenSession()
    });
  }

  renderNotifications = () => {
    return (
      <Notifications notifications={this.joinNotifications()} />
    );
  }

  render() {
    const { t } = this.props;
    const permissionStatus = this.props.getPermissionStatus(MENU.ASSISTANT);

    return (
      <div>
        <h2 className="page-header">{t('dashboard.assistant.heading')}</h2>
        {this.state.notifications ? (
          this.state.notifications.messages.length || this.state.notifications.deliveries.length ? (
            null
          ) : (
            <div>
              <h2 className="page-header">
                {t('dashboard.assistant.no_results')}
              </h2>
            </div>
          )
        ) : (
         null
        )
        }
        {permissionStatus && <div className="jumbotron alert-warning">{permissionStatus}</div>}
        {!permissionStatus && this.hasNotifications() && this.renderNotifications()}
      </div>
    );
  }
}

export default translate('common')(AssistantContainer);



// WEBPACK FOOTER //
// ./src/dashboard/assistant/AssistantContainer.js